var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.type !== "list"
        ? [
            _c(
              "div",
              { staticClass: "divBox" },
              [
                _c(
                  "el-card",
                  {
                    staticClass: "card-box mt14",
                    attrs: { "body-style": { padding: "0 0 20px 0" } },
                  },
                  [
                    _c("div", { staticClass: "header-box" }, [
                      _c("div", { staticClass: "left" }, [
                        _c("i", {
                          staticClass: "el-icon-arrow-left",
                          on: { click: _vm.goBack },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "invoice-logo" }, [
                          _c("i", { staticClass: "icon iconfont iconhetong" }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "right" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.name || "--")),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "header mr20" }, [
                      _c(
                        "div",
                        { staticClass: "title" },
                        [
                          _c("el-input", {
                            ref: "inputFocus",
                            attrs: { placeholder: "请输入评估表名称" },
                            model: {
                              value: _vm.name,
                              callback: function ($$v) {
                                _vm.name = $$v
                              },
                              expression: "name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "tips" }, [
                        _vm._v("列表支持拖拽排序"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pr20" },
                      [
                        _c(
                          "el-table",
                          {
                            ref: "table",
                            staticClass: "table ml20",
                            staticStyle: { width: "100%" },
                            attrs: { data: _vm.list, "row-key": "col1" },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "position",
                                label: "职位",
                                "min-width": "100",
                                fixed: "left",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function (scope) {
                                      return [
                                        _c("select-member", {
                                          ref: "selectMember",
                                          on: {
                                            getSelectList: _vm.getSelectList,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "custom",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "department",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.selectPosition(
                                                              $event
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      选择人员 "
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-arrow-down",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              size: "mini",
                                              placeholder: "请选择",
                                            },
                                            on: { focus: _vm.selectedPosition },
                                            model: {
                                              value: scope.row.col1,
                                              callback: function ($$v) {
                                                _vm.$set(scope.row, "col1", $$v)
                                              },
                                              expression: "scope.row.col1",
                                            },
                                          },
                                          _vm._l(_vm.position, function (item) {
                                            return _c("el-option", {
                                              key: item.id,
                                              attrs: {
                                                label: item.name,
                                                value: item.id,
                                                disabled:
                                                  _vm.selectedList.includes(
                                                    item.id
                                                  ),
                                              },
                                            })
                                          }),
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                662659742
                              ),
                            }),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              { attrs: { label: "知识水平(A)" } },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "col2",
                                    label: "专业知识水平",
                                    "min-width": "130",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  placement: "top",
                                                  width: "400",
                                                  trigger: "hover",
                                                  content:
                                                    "专业知识水平指对该职位要求从事的职业领域的理论、实际方法与专门性知识的了解",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: {
                                                      slot: "reference",
                                                    },
                                                    slot: "reference",
                                                  },
                                                  [
                                                    _vm._v("专业知识水平 "),
                                                    _c("span", {
                                                      staticClass:
                                                        "el-icon-info",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value: scope.row.col2,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "col2",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.col2",
                                                },
                                              },
                                              _vm._l(
                                                _vm.professionalKnowledge,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.id,
                                                    attrs: {
                                                      label: item.label,
                                                      value: item.id,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2665399421
                                  ),
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "col3",
                                    label: "管理诀窍",
                                    "min-width": "100",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  placement: "top",
                                                  width: "400",
                                                  trigger: "hover",
                                                  content:
                                                    "管理诀窍是指在领导和管理他人时所需的技巧和策略，包括有效沟通、目标设定、团队建设等方面的知识和技能",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: {
                                                      slot: "reference",
                                                    },
                                                    slot: "reference",
                                                  },
                                                  [
                                                    _vm._v("管理诀窍 "),
                                                    _c("span", {
                                                      staticClass:
                                                        "el-icon-info",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value: scope.row.col3,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "col3",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.col3",
                                                },
                                              },
                                              _vm._l(
                                                _vm.managementKnowHow,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.id,
                                                    attrs: {
                                                      label: item.label,
                                                      value: item.id,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2927935092
                                  ),
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "col4",
                                    label: "人际关系技巧",
                                    "min-width": "100",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  placement: "top",
                                                  width: "400",
                                                  trigger: "hover",
                                                  content:
                                                    "人际关系技巧是指在与他人相处和合作时，建立良好关系、处理冲突、激发合作等方面的技巧和能力",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: {
                                                      slot: "reference",
                                                    },
                                                    slot: "reference",
                                                  },
                                                  [
                                                    _vm._v("人际关系技巧"),
                                                    _c("span", {
                                                      staticClass:
                                                        "el-icon-info",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value: scope.row.col4,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "col4",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.col4",
                                                },
                                              },
                                              _vm._l(
                                                _vm.interpersonalRelationship,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.id,
                                                    attrs: {
                                                      label: item.label,
                                                      value: item.id,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3962032491
                                  ),
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "col5",
                                    label: "评分",
                                    "min-width": "70",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  disabled:
                                                    !_vm.score[
                                                      _vm.getScore(
                                                        scope.row.col2,
                                                        scope.row.col3,
                                                        scope.row.col4
                                                      )
                                                    ],
                                                  size: "mini",
                                                  placeholder: "请选择",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.positionScore(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: scope.row.col5,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "col5",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.col5",
                                                },
                                              },
                                              _vm._l(
                                                _vm.score[
                                                  _vm.getScore(
                                                    scope.row.col2,
                                                    scope.row.col3,
                                                    scope.row.col4
                                                  )
                                                ],
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.id,
                                                    attrs: {
                                                      label: item.label,
                                                      value: item.id,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    799634618
                                  ),
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              { attrs: { label: "解决问题(B)" } },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "col6",
                                    label: "思维环境",
                                    "min-width": "120",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  placement: "top",
                                                  width: "400",
                                                  trigger: "hover",
                                                  content:
                                                    "思维环境是指工作中需要运用特定的思维方式和技巧的情境或背景",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: {
                                                      slot: "reference",
                                                    },
                                                    slot: "reference",
                                                  },
                                                  [
                                                    _vm._v("思维环境 "),
                                                    _c("span", {
                                                      staticClass:
                                                        "el-icon-info",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value: scope.row.col6,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "col6",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.col6",
                                                },
                                              },
                                              _vm._l(
                                                _vm.environment,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.id,
                                                    attrs: {
                                                      label: item.label,
                                                      value: item.id,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    720340285
                                  ),
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "col7",
                                    label: "思维难度",
                                    "min-width": "100",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  placement: "top",
                                                  width: "400",
                                                  trigger: "hover",
                                                  content:
                                                    "思维难度指的是问题的复杂程度或解决问题所需的认知挑战程度",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: {
                                                      slot: "reference",
                                                    },
                                                    slot: "reference",
                                                  },
                                                  [
                                                    _vm._v("思维难度 "),
                                                    _c("span", {
                                                      staticClass:
                                                        "el-icon-info",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value: scope.row.col7,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "col7",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.col7",
                                                },
                                              },
                                              _vm._l(
                                                _vm.difficulty,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.id,
                                                    attrs: {
                                                      label: item.label,
                                                      value: item.id,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    494799318
                                  ),
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "col8",
                                    label: "评分",
                                    "min-width": "70",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  disabled:
                                                    !_vm.solve[
                                                      _vm.getSolve(
                                                        scope.row.col6,
                                                        scope.row.col7
                                                      )
                                                    ],
                                                  size: "mini",
                                                  placeholder: "请选择",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.positionScore(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: scope.row.col8,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "col8",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.col8",
                                                },
                                              },
                                              _vm._l(
                                                _vm.solve[
                                                  _vm.getSolve(
                                                    scope.row.col6,
                                                    scope.row.col7
                                                  )
                                                ],
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.id,
                                                    attrs: {
                                                      label: item.label,
                                                      value: item.id,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3583696055
                                  ),
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              { attrs: { label: "承担责任(C)" } },
                              [
                                _c("el-table-column", {
                                  attrs: { prop: "col9", "min-width": "120" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  placement: "top",
                                                  width: "400",
                                                  trigger: "hover",
                                                  content:
                                                    "行动自由度指的是在职位中能够自主决策和采取行动的程度",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: {
                                                      slot: "reference",
                                                    },
                                                    slot: "reference",
                                                  },
                                                  [
                                                    _vm._v("行动自由度 "),
                                                    _c("span", {
                                                      staticClass:
                                                        "el-icon-info",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value: scope.row.col9,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "col9",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.col9",
                                                },
                                              },
                                              _vm._l(_vm.free, function (item) {
                                                return _c("el-option", {
                                                  key: item.id,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.id,
                                                  },
                                                })
                                              }),
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    4074224380
                                  ),
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { prop: "col10", "min-width": "100" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  placement: "top",
                                                  width: "400",
                                                  trigger: "hover",
                                                  content:
                                                    "职务责任是指职位所要承担的具体职责和义务",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: {
                                                      slot: "reference",
                                                    },
                                                    slot: "reference",
                                                  },
                                                  [
                                                    _vm._v("职务责任 "),
                                                    _c("span", {
                                                      staticClass:
                                                        "el-icon-info",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value: scope.row.col10,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "col10",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.col10",
                                                },
                                              },
                                              _vm._l(
                                                _vm.responsibility,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.id,
                                                    attrs: {
                                                      label: item.label,
                                                      value: item.id,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2895940843
                                  ),
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { prop: "col11", "min-width": "110" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  placement: "top",
                                                  width: "400",
                                                  trigger: "hover",
                                                  content:
                                                    "职务影响结果指的是职位对于组织和业务结果的影响程度",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: {
                                                      slot: "reference",
                                                    },
                                                    slot: "reference",
                                                  },
                                                  [
                                                    _vm._v("职务影响结果 "),
                                                    _c("span", {
                                                      staticClass:
                                                        "el-icon-info",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("el-cascader", {
                                              attrs: {
                                                size: "mini",
                                                options: _vm.influence,
                                              },
                                              model: {
                                                value: scope.row.col11,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "col11",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.col11",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1451266583
                                  ),
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "col12",
                                    label: "评分",
                                    "min-width": "70",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  disabled:
                                                    !_vm.bear[
                                                      _vm.getBear(
                                                        scope.row.col9,
                                                        scope.row.col10,
                                                        scope.row.col11
                                                      )
                                                    ],
                                                  size: "mini",
                                                  placeholder: "请选择",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.positionScore(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: scope.row.col12,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "col12",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.col12",
                                                },
                                              },
                                              _vm._l(
                                                _vm.bear[
                                                  _vm.getBear(
                                                    scope.row.col9,
                                                    scope.row.col10,
                                                    scope.row.col11
                                                  )
                                                ],
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.id,
                                                    attrs: {
                                                      label: item.label,
                                                      value: item.id,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3353752396
                                  ),
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-popover",
                                            {
                                              attrs: {
                                                placement: "top",
                                                width: "400",
                                                trigger: "hover",
                                                content:
                                                  "通过技能、解决问题能力和职务责任的不同要求，区分不同类型的职位，以对各种职位进行划分，实行不同的薪酬结构。α：知识水平与解决问题权重(20<α<80) ；β：承担责任权重",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "reference" },
                                                  slot: "reference",
                                                },
                                                [
                                                  _vm._v("权重设置"),
                                                  _c("span", {
                                                    staticClass: "el-icon-info",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3760353137
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { "min-width": "100" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function (scope) {
                                          return [_c("div", [_vm._v("（α）")])]
                                        },
                                      },
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-input",
                                              {
                                                staticClass: "input",
                                                attrs: {
                                                  type: "number",
                                                  size: "mini",
                                                  min: "20",
                                                  max: "80",
                                                  placeholder: "请输入整数",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.positionScore(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: scope.row.col13,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "col13",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.col13",
                                                },
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticStyle: {
                                                      "font-style": "normal",
                                                      "margin-right": "10px",
                                                    },
                                                    attrs: { slot: "suffix" },
                                                    slot: "suffix",
                                                  },
                                                  [_vm._v("%")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    622092077
                                  ),
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { "min-width": "100" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function (scope) {
                                          return [_c("div", [_vm._v("（β）")])]
                                        },
                                      },
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-input",
                                              {
                                                staticClass: "input",
                                                attrs: {
                                                  size: "mini",
                                                  disabled: "",
                                                  placeholder: "自动计算",
                                                },
                                                model: {
                                                  value: scope.row.col14,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "col14",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.col14",
                                                },
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticStyle: {
                                                      "font-style": "normal",
                                                      "margin-right": "10px",
                                                    },
                                                    attrs: { slot: "suffix" },
                                                    slot: "suffix",
                                                  },
                                                  [_vm._v("%")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2492888723
                                  ),
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { "min-width": "80" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-popover",
                                          {
                                            attrs: {
                                              placement: "top",
                                              width: "250",
                                              trigger: "hover",
                                              content:
                                                "岗位分数= αA*(1+B) + βC",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "reference" },
                                                slot: "reference",
                                              },
                                              [
                                                _vm._v("岗位分数 "),
                                                _c("span", {
                                                  staticClass: "el-icon-info",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            size: "mini",
                                            disabled: "",
                                            placeholder: "自动计算",
                                          },
                                          model: {
                                            value: scope.row.col15,
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, "col15", $$v)
                                            },
                                            expression: "scope.row.col15",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                273302754
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { "min-width": "80" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-popover",
                                          {
                                            attrs: {
                                              placement: "top",
                                              width: "250",
                                              trigger: "hover",
                                              content:
                                                "岗位系数=岗位分数/最低岗位分数",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "reference" },
                                                slot: "reference",
                                              },
                                              [
                                                _vm._v("岗位系数 "),
                                                _c("span", {
                                                  staticClass: "el-icon-info",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            size: "mini",
                                            disabled: "",
                                            placeholder: "自动计算",
                                          },
                                          model: {
                                            value: scope.row.col16,
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, "col16", $$v)
                                            },
                                            expression: "scope.row.col16",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                979101145
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "操作",
                                width: "100",
                                fixed: "right",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.col1
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.openHistory(
                                                      scope
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("历史")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteFn(scope)
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1192743785
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "add-row ml20",
                        on: { click: _vm.addANewLine },
                      },
                      [
                        _c("span", { staticClass: "el-icon-plus" }),
                        _vm._v(" 添加行"),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cr-bottom-button btn-shadow" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.exportExcelData },
                      },
                      [_vm._v("下载")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "small",
                          loading: _vm.loading,
                          type: "primary",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.submit()
                          },
                        },
                      },
                      [_vm._v("保存")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.type == "list"
        ? _c("tableList", {
            on: { addType: _vm.addType, editType: _vm.editType },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("historyList", { ref: "history", on: { applyFn: _vm.applyFn } }),
      _vm._v(" "),
      _c("export-excel", {
        ref: "exportExcel",
        attrs: {
          template: false,
          "save-name": _vm.saveName,
          "export-data": _vm.exportData,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }